<template>
  <WsRead
    :modelName="modelName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="name"
    :isMultiSelect="true"
    :showExpand="false"
  >
  </WsRead>
</template>

<script>
import model from "@/models/admin";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    localeMode: true,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "管理者資訊",
              fields: ["sequence", "name", "email", "roles", "scopes"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "建立資訊",
              fields: ["created_at", "created_admin"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "編輯資訊",
              fields: ["updated_at", "updated_admin"],
            },
          ],
        },
        {
          type: "activeSwitch",
          title: "啟用設定",
          remark: "停用的管理者將無法使用管理後台介面",
          field: "is_active",
        },
      ],
    },
  }),
};
</script>